import React, {
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
} from 'react';
import { Trigger } from '@radix-ui/react-popover';

export const PopoverTrigger: React.FC<{
  asChild?: boolean;
  trigger: ReactNode;
  handleTriggerClick: MouseEventHandler<HTMLElement>;
  mouseEventHandler: (isMouseOver: boolean) => void;
  onKeyUp?: KeyboardEventHandler<HTMLElement>;
}> = ({ asChild, trigger, handleTriggerClick, mouseEventHandler, onKeyUp }) => {
  return (
    <Trigger
      asChild={asChild}
      onClick={handleTriggerClick}
      onMouseEnter={() => mouseEventHandler(true)}
      onMouseLeave={() => mouseEventHandler(false)}
      onKeyUp={asChild ? undefined : onKeyUp}
      tabIndex={asChild ? undefined : 0}
    >
      {trigger}
    </Trigger>
  );
};
